import { message } from 'antd';
import { getSizeValues } from '../../utils/sizeOptions';
import { getVariantStockQuantity, isVariantAvailable } from '../../utils/variantInventory';
import {
  getNextValidSizeForMaterial,
  getSizeAvailabilityMessage,
} from '../../utils/cartValidation';
import type { MaterialSelectorCartItem, MaterialSelectorOption } from '../interfaces';

export const getNextCartMaterialSize = (
  material: MaterialSelectorOption,
  cartItem?: MaterialSelectorCartItem
) => {
  if (!cartItem) return '';

  return getNextValidSizeForMaterial({
    material,
    productSizes: cartItem.product.sizes || [],
    currentSize: cartItem.selectedSize || '',
    productId: cartItem.product.id,
    quantity: cartItem.quantity,
  });
};

export const validateCartMaterialSelection = (
  material: MaterialSelectorOption,
  cartItem: MaterialSelectorCartItem,
  nextCartSize: string
) => {
  const materialName = material.materialName;
  const materialSizes = getSizeValues(material.sizes);
  const stockQuantity = getVariantStockQuantity(material, nextCartSize, cartItem.product.id);

  if (materialSizes.length && !nextCartSize) {
    const firstMaterialSize = materialSizes[0];
    const reason = firstMaterialSize
      ? getSizeAvailabilityMessage({
        material,
        productId: cartItem.product.id,
        selectedSize: firstMaterialSize,
        quantity: cartItem.quantity,
      })
      : `${materialName} has no available sizes.`;
    message.warning(reason || `${materialName} has no available sizes.`);
    return false;
  }

  if (!isVariantAvailable(material, nextCartSize, cartItem.product.id)) {
    message.warning(`${materialName} ${nextCartSize ? `size ${nextCartSize}` : ''} is currently unavailable.`);
    return false;
  }

  if (typeof stockQuantity === 'number' && stockQuantity <= 0) {
    message.warning(`${materialName} is currently out of stock.`);
    return false;
  }

  if (typeof stockQuantity === 'number' && cartItem.quantity > stockQuantity) {
    message.warning(`Only ${stockQuantity} ${materialName} item(s) available in stock.`);
    return false;
  }

  return true;
};
